import { ADD_TO_CART, REMOVE_FROM_CART } from "../products/actionType";

export const validate = (store) => (next) => (action) => {
  const state = store.getState();

  const newItem = state.products.find(
    (item) => item.productId === action.payload
  );

  if (newItem.Qty <= 0) {
    switch (action.type) {
      case ADD_TO_CART:
        return alert(`${newItem.productName} is out of stock`);
      //alternatively we can dispatch another action from here
      case REMOVE_FROM_CART:
        return next(action);

      default:
        break;
    }
  }
  return next(action);
};
